import { AbacoWebModule, MenuItem } from '@abaco/web-common/src/app';
import globals from "./globals";
import myRoutes from "./routes";
import { HTTPClient } from '@abaco/web-common/src/HTTP';
import HelperApi from './api/HelperApi';
import HelperVuexModule from './state';
import { DashboardPinnedStatus } from './models/Helper';
import { createMenu } from './menu';
import { RouterReadyEvent } from '@abaco/web-common/src/app/Application';

export const MODULE_ID = "helper_module";

export default class HelperModule implements AbacoWebModule {
    public static MODULE_ID = MODULE_ID;

    private apiCreated = false;
    private hlpApi!: HelperApi;
    private http!: HTTPClient;

    readonly id = MODULE_ID;
    readonly routes = myRoutes;
    readonly globalComponents = globals;
    readonly vuexModule = new HelperVuexModule();
    menu: MenuItem[] = [];

    onRouterReady(evt: RouterReadyEvent) {
        this.menu = createMenu(evt.router);
        this.http = evt.http;
    }

    async beforeEnterAnyRoutes(http: HTTPClient) {
        if (this.apiCreated) {
            return;
        }
        this.apiCreated = true;
        const HelperApi = (await import("./api/HelperApi")).default;
        this.hlpApi = new HelperApi(http);
    }

    public get helperApi() {
        return this.hlpApi;
    }

    public setIsFirstLogin(val: boolean) {
        this.vuexModule.isFirstLogin = val;
    }

    public setDashboardPinnedStatus(val: DashboardPinnedStatus) {
        this.vuexModule.dashboardPinnedStatus = val;
    }

    public async needsHelp(isBasicUser: boolean) {
        try {
            await this.beforeEnterAnyRoutes(this.http);

            const alreadyDone = await this.helperApi.alreadyDone();

            if (alreadyDone || !isBasicUser) {
                this.setIsFirstLogin(false);
                return false;
            }
            this.helperApi.setDoNotShowAnymore();
            this.setIsFirstLogin(true);
            this.setDashboardPinnedStatus("ok");
            return true;
        } catch (error) {
            console.error(error);
            return false;
        }
    }
}
